var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createGlobalStyle } from "styled-components";
import styled from "styled-components";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @import url('https://fonts.googleapis.com/css2?family=Varela+Round&display=swap');\n  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');\n"], ["\n  @import url('https://fonts.googleapis.com/css2?family=Varela+Round&display=swap');\n  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');\n"])));
var commonStyles = "\n  padding: 0;\n  margin: 0;\n";
var StyledH1 = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  ", "\n  font-family: ", ";\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  ", "\n  font-family: ", ";\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "2.5rem"
        : props.$size === "medium"
            ? "2.25rem"
            : "2rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$lineHeight === "large")
        ? "4rem"
        : props.$size === "medium"
            ? "3.5rem"
            : "3rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "\"Lato\", sans-serif"; }, commonStyles);
var StyledH2 = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "2.25rem"
        : props.$size === "medium"
            ? "2rem"
            : "1.75rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "3.5rem"
        : props.$size === "medium"
            ? "3rem"
            : "2.5rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "\"Lato\", sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledH3 = styled.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "2rem"
        : props.$size === "medium"
            ? "1.75rem"
            : "1.5rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "3rem"
        : props.$size === "medium"
            ? "2.5rem"
            : "2rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "\"Lato\", sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledH4 = styled.h4(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.75rem"
        : props.$size === "medium"
            ? "1.5rem"
            : "1.25rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "2.5rem"
        : props.$size === "medium"
            ? "2rem"
            : "1.75rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "\"Lato\", sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledH5 = styled.h5(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.5rem"
        : props.$size === "medium"
            ? "1.25rem"
            : "1rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "2rem"
        : props.$size === "medium"
            ? "1.75rem"
            : "1.5rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "\"Lato\", sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledH6 = styled.h6(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.25rem"
        : props.$size === "medium"
            ? "1rem"
            : "0.875rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.75rem"
        : props.$size === "medium"
            ? "1.5rem"
            : "1.25rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "\"Lato\", sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledDiv = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.25rem"
        : props.$size === "medium"
            ? "1rem"
            : "0.875rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.75rem"
        : props.$size === "medium"
            ? "1.5rem"
            : "1.25rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "'Varela Round', sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledLabel = styled.label(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.25rem"
        : props.$size === "medium"
            ? "1rem"
            : "0.75rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.75rem"
        : props.$size === "medium"
            ? "1.5rem"
            : "1.25rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "'Varela Round', sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledSpan = styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.25rem"
        : props.$size === "medium"
            ? "1rem"
            : "0.875rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.75rem"
        : props.$size === "medium"
            ? "1.5rem"
            : "1.25rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "'Varela Round', sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var StyledP = styled.p(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  ", "\n  ", "\n"])), function (props) {
    var _a;
    return ((_a = props.$fontSize) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.25rem"
        : props.$size === "medium"
            ? "1rem"
            : "0.875rem";
}, function (props) {
    var _a;
    return ((_a = props.$lineHeight) !== null && _a !== void 0 ? _a : props.$size === "large")
        ? "1.75rem"
        : props.$size === "medium"
            ? "1.5rem"
            : "1.25rem";
}, function (props) { return (props.$strong ? "700" : "400"); }, function (props) { var _a; return (_a = props.$fontFamily) !== null && _a !== void 0 ? _a : "'Varela Round', sans-serif"; }, function (props) { return !props.$noColor && "color: ".concat(props.$color, ";"); }, commonStyles);
var Text = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "div" : _b, strong = _a.strong, children = _a.children, _c = _a.align, align = _c === void 0 ? "center" : _c, color = _a.color, _d = _a.wrap, wrap = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "medium" : _e, _f = _a.noColor, noColor = _f === void 0 ? false : _f, fontSize = _a.fontSize, lineHeight = _a.lineHeight, style = _a.style, className = _a.className, fontFamily = _a.fontFamily, rest = __rest(_a, ["variant", "strong", "children", "align", "color", "wrap", "size", "noColor", "fontSize", "lineHeight", "style", "className", "fontFamily"]);
    var colorPalette = useTheme().theme.colorPalette;
    var _color = color
        ? colorPalette[color].main
        : colorPalette.primary.grayScale[11];
    var _styleProps = { $noColor: noColor, $color: _color };
    var _Text = function () {
        switch (variant) {
            case "h1":
                return (_jsx(StyledH1, __assign({ "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "h2":
                return (_jsx(StyledH2, __assign({ "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "h3":
                return (_jsx(StyledH3, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "h4":
                return (_jsx(StyledH4, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "h5":
                return (_jsx(StyledH5, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "h6":
                return (_jsx(StyledH6, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "div":
                return (_jsx(StyledDiv, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "paragraph":
                return (_jsx(StyledP, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "label":
                return (_jsx(StyledLabel, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            case "span":
                return (_jsx(StyledSpan, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
            default:
                return (_jsx(StyledDiv, __assign({ "$variant": variant, "$strong": strong, "$align": align, "$wrap": wrap, "$size": size, "$fontSize": fontSize, "$lineHeight": lineHeight, style: style, className: className }, rest, _styleProps, { children: children })));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), _Text()] }));
};
export default Text;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
